import { BoardTemplateEnum } from "./types";
import list from "assets/imgs/list.png";
import kanban from "assets/imgs/kanban.png";
import agile from "assets/imgs/agile.png";
import releases from "assets/imgs/releases.png";
import bugs from "assets/imgs/bugs.png";
import design from "assets/imgs/design.png";
import roadmap from "assets/imgs/roadmap.png";
import management from "assets/imgs/management.png";



export const userDetailsData = {
  name: "John Doe",
  initials: "JD",
  email: "john.doe@example.com",
  role: "Administrator",
  status: "Online",
  lastLogin: "2024-11-14 10:30 AM",
  localTime: "10:30 AM",
};

export const memberData = [
  {
    id: "abc1",
    name: "John Doe",
    role: "Developer",
    email: "john.snow@example.com",
    team: "Digital Innovators Collective",
    status: "Online",
    lastLogin: "1 Sep, 2:15 pm",
    localTime: "3:00 pm",
    location: "Israel, Tel Aviv",
    spokenLanguages: "English, Hebrew",
    mobileNumber: "+972 45 569 5236",
    creationDate: "10 Jun, 2023",
  },
  {
    id: "abc2",
    name: "Jane Smith",
    role: "Project Manager",
    email: "smith@example.com",
    team: "Digital Innovators Collective",
    status: "Online",
    lastLogin: "2 Sep, 3:00 pm",
    localTime: "3:00 pm",
    location: "Israel, Tel Aviv 1",
    spokenLanguages: "English, Hebrew",
    mobileNumber: "+972 45 569 5237",
    creationDate: "19 Jun, 2023",
  },
];

// static-data for the favourite side bar items
export const FavList = [
  {
    id: "1",
    content: "QA bugs board",
    icon: { name: "ticket", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/2/board",
  },
  {
    id: "2",
    content: "Developer dashboard",
    icon: { name: "boards", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/3/board",
  },
  {
    id: "3",
    content: "Ticket id 000101",
    icon: { name: "ticket", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/backlog",
  },
  {
    id: "4",
    content: "QA bugs board",
    icon: { name: "dashboard", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/2/board",
  },
  {
    id: "5",
    content: "Developer dashboard",
    icon: { name: "boards", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/3/board",
  },
  {
    id: "6",
    content: "Ticket id 000101",
    icon: { name: "dashboard", size: 20, color: "#79808A" },
    navigateTo: "/app/1/1/boards/backlog",
  },
];


export const projectLink = [
  { name: "Tickets" },
  { name: "Sprints" },
  { name: "Releases" },
];

export const BOARD_TEMP_OPTIONS = [
  {
    title: "List",
    caption: "Organized & simple list of tasks",
    img: list,
    type: BoardTemplateEnum.LIST,
  },
  {
    title: "Kanban",
    caption: "Move tasks between columns",
    img: kanban,
    type: BoardTemplateEnum.KANBAN,
  },
  {
    title: "Agile Development",
    caption: "Streamline Agile workflows from backlog to completion.",
    img: agile,
    type: BoardTemplateEnum.AGILE_DEVELOPMENT,
  },
  {
    title: "Release Management",
    caption:
      "Manage software releases, CI/CD pipelines, and deployment processes.",
    img: releases,
    type: BoardTemplateEnum.RELEASE_MANAGEMENT,
  },
  {
    title: "Bug Tracking",
    caption:
      "Track and resolve bugs and issues efficiently through their lifecycle.",
    img: bugs,
    type: BoardTemplateEnum.BUG_TRACKING,
  },
  {
    title: "Design and Prototyping",
    caption: "Streamline design tasks from concept to user testing.",
    img: design,
    type: BoardTemplateEnum.DESIGN_AND_PROTOTYPING,
  },
  {
    title: "Product Roadmap",
    caption: "Plan and track feature development and product releases.",
    img: roadmap,
    type: BoardTemplateEnum.PRODUCT_ROADMAP,
  },
  {
    title: "General Project Management",
    caption: "Oversee software project from start to end.",
    img: management,
    type: BoardTemplateEnum.GENERAL_PROJECT_MANAGEMENT,
  },
];